import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_socials-twitter",
  "use": "icon_socials-twitter-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon_socials-twitter\"><path fill=\"currentColor\" d=\"M9.28931 6.928 14.3523 1h-1.2L8.75731 6.147 5.24531 1h-4.05l5.31 7.784-5.31 6.216h1.2l4.642-5.436L10.7463 15h4.05L9.28931 6.928Zm-1.643 1.924-.538-.775-4.281-6.167h1.843l3.454 4.977.538.775 4.49099 6.47h-1.843l-3.66399-5.28Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol